export default function handleLogoGrid() {

    // Get all of the .logo-grid <ul> elements:
    const logoGridLists = document.querySelectorAll('.logo-grid ul');

    // If there are no .logo-grid <ul> elements, stop processing this script:
    if (!logoGridLists.length) return;

    // Define how long a list should remain in view:
    const listVisibleDuration = 2000;

    // Define how long to wait before showing the next <li>:
    const listItemWaitDuration = 125;

     // Index of the currently shown <ul> element:
    let currentListIndex = 0;

    // Function to toggle visibility of <ul> elements:
    function toggleListVisibility() {

        // Get the current <ul> element:
        const currentList = logoGridLists[currentListIndex];

        // Add a class to the current <ul> element:
        currentList.classList.add('is-visible');

        // Get the child <li> elements of the current <ul> element:
        const lis = currentList.getElementsByTagName('li');

        // Stagger the addition of the 'is-visible' class to each <li> element:
        let delay = 0;

        for (let i = 0; i < lis.length; i++) {
            setTimeout(function() {
                lis[i].classList.add('is-visible');
            }, delay);
            delay += listItemWaitDuration;
        }

        // Stagger the removal of the 'is-visible' class from each <li> element:
        setTimeout(function() {
            for (let i = 0; i < lis.length; i++) {
                setTimeout(function() {
                    lis[i].classList.remove('is-visible');
                }, i * listItemWaitDuration);
            }

            // Remove a class from the current <ul> element after removing the 'is-visible' class
            setTimeout(function() {
                currentList.classList.remove('is-visible');
            }, lis.length * listItemWaitDuration);
        }, listVisibleDuration);

        // Increment the current index or reset to 0 if it exceeds the number of <ul> elements:
        currentListIndex = (currentListIndex + 1) % logoGridLists.length;
    }

    // Call the toggleListVisibility function right away:
    toggleListVisibility();

    // …and again every { listVisibleDuration } seconds:
    setInterval(toggleListVisibility, listVisibleDuration);
}
